<template>
    <span>
        <div class="uk-text-center">
            <div uk-spinner />
            <div class="uk-margin-small-top">
                <Translate translation-key="terminal.connector.waiting" />
            </div>
        </div>

        <div class="uk-margin-medium-top" />

        <!-- it answers 503 while running but not set up with the setup code -->
        <InfoBox mode="danger" :is-round="isRound">
            <Translate
                :translation-key="
                    $store.state.terminalConnectorReachable
                        ? 'terminal.connector.not.registered'
                        : 'terminal.connector.not.running'
                " />
        </InfoBox>
    </span>
</template>

<script>
import Translate from '@/components/Translate.vue';
import InfoBox from '@/components/generic/InfoBox.vue';

export default {
    name: 'TerminalConnnectorNotRunnning',
    components: {InfoBox, Translate},
    props: {
        // the new views; the old frame keeps the square box
        isRound: Boolean,
    },
};
</script>

<style lang="scss" scoped></style>
